import Intercom from "@intercom/messenger-js-sdk"
import { User } from "../types"

const INTERCOM_APP_ID = process.env.REACT_APP_INTERCOM_APP_ID || ""

export const bootIntercom = (user: User): void => {
  if (!INTERCOM_APP_ID || !user) return

  const buildUserId = () => {
    const userId = user.id?.toString() || "guest"
    const currentUrl = window.location.href
    if (currentUrl.includes("localhost")) {
      return `artist-local-${userId}`
    } else if (currentUrl.includes("artists-qa")) {
      return `artist-qa-${userId}`
    }
    return userId
  }

  Intercom({
    app_id: INTERCOM_APP_ID,
    user_id: buildUserId(),
    name: `${user.firstName} ${user.lastName}`.trim(),
    email: user.email,
    phone: user.phone || undefined,
    company: user.company
      ? {
          company_id: user.id?.toString(),
          name: user.company
        }
      : undefined,
    custom_launcher_selector: "#intercom-launcher",
    hide_default_launcher: false,
    user_hash: undefined
  })
}

export const updateIntercom = (user: User): void => {
  if (!INTERCOM_APP_ID || typeof window === "undefined" || !window.Intercom) return

  window.Intercom("update", {
    user_id: user.id?.toString(),
    name: `${user.firstName} ${user.lastName}`.trim(),
    email: user.email,
    phone: user.phone || undefined
  })
}

export const shutdownIntercom = (): void => {
  if (typeof window === "undefined" || !window.Intercom) return
  window.Intercom("shutdown")
}

export const showIntercom = (): void => {
  if (typeof window === "undefined" || !window.Intercom) return
  window.Intercom("show")
}

export const hideIntercom = (): void => {
  if (typeof window === "undefined" || !window.Intercom) return
  window.Intercom("hide")
}

declare global {
  interface Window {
    Intercom: any
  }
}
